
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ForbiddenSvg extends Vue{
	@Prop({ default: 178 }) private size: number;
}
